module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/ReserveButton/images/battle-normal-50.5763cf24.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/ReserveButton/images/battle-normal-50.png
// module id = 3418
// module chunks = 11